import ArrowBack from "../icons/arrow-back";
import ArrowForward from "../icons/arrow-forward";
import Assistance from "../icons/assistance";
import Birthday from "../icons/birthday";
import Blocking from "../icons/blocking";
import Calculator from "../icons/calculator";
import Call from "../icons/call";
import ChevronDown from "../icons/chevron-down";
import ChevronLeft from "../icons/chevron-left";
import ChevronRight from "../icons/chevron-right";
import ChevronUp from "../icons/chevron-up";
import Comparison from "../icons/comparison";
import Critical from "../icons/critical";
import CrossSmall from "../icons/cross-small";
import Cross from "../icons/cross";
import Devices from "../icons/devices";
import Document from "../icons/document";
import Download from "../icons/download";
import Duplicate from "../icons/duplicate";
import Edit from "../icons/edit";
import ExternalLink from "../icons/external-link";
import EyeHidden from "../icons/eye-hidden";
import EyeVisible from "../icons/eye-visible";
import FaceId from "../icons/face-id";
import Facebook from "../icons/facebook";
import Fingerprint from "../icons/fingerprint";
import Github from "../icons/github";
import Hamburger from "../icons/hamburger";
import Home from "../icons/home";
import InfoOrMinor from "../icons/info-or-minor";
import Instagram from "../icons/instagram";
import Link from "../icons/link";
import Linkedin from "../icons/linkedin";
import LockSmall from "../icons/lock-small";
import Lock from "../icons/lock";
import Logout from "../icons/logout";
import Mail from "../icons/mail";
import Message from "../icons/message";
import NotificationNew from "../icons/notification-new";
import Notification from "../icons/notification";
import OverflowMenu from "../icons/overflow-menu";
import Payment from "../icons/payment";
import Person from "../icons/person";
import Question from "../icons/question";
import Search from "../icons/search";
import SelectObject from "../icons/select-object";
import Shield from "../icons/shield";
import Stop from "../icons/stop";
import StopwatchAlt from "../icons/stopwatch-alt";
import Stopwatch from "../icons/stopwatch";
import Success from "../icons/success";
import TickSmall from "../icons/tick-small";
import Tick from "../icons/tick";
import Time from "../icons/time";
import Trash from "../icons/trash";
import TriangleDown from "../icons/triangle-down";
import TriangleUp from "../icons/triangle-up";
import Twitter from "../icons/twitter";
import WarningOrSignificant from "../icons/warning-or-significant";
import Youtube from "../icons/youtube";
export var iconListMapping = {
  "arrow-back": ArrowBack,
  "arrow-forward": ArrowForward,
  assistance: Assistance,
  birthday: Birthday,
  blocking: Blocking,
  calculator: Calculator,
  call: Call,
  "chevron-down": ChevronDown,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "chevron-up": ChevronUp,
  comparison: Comparison,
  critical: Critical,
  "cross-small": CrossSmall,
  cross: Cross,
  devices: Devices,
  document: Document,
  download: Download,
  duplicate: Duplicate,
  edit: Edit,
  "external-link": ExternalLink,
  "eye-hidden": EyeHidden,
  "eye-visible": EyeVisible,
  "face-id": FaceId,
  facebook: Facebook,
  fingerprint: Fingerprint,
  github: Github,
  hamburger: Hamburger,
  home: Home,
  "info-or-minor": InfoOrMinor,
  instagram: Instagram,
  link: Link,
  linkedin: Linkedin,
  "lock-small": LockSmall,
  lock: Lock,
  logout: Logout,
  mail: Mail,
  message: Message,
  "notification-new": NotificationNew,
  notification: Notification,
  "overflow-menu": OverflowMenu,
  payment: Payment,
  person: Person,
  question: Question,
  search: Search,
  "select-object": SelectObject,
  shield: Shield,
  stop: Stop,
  "stopwatch-alt": StopwatchAlt,
  stopwatch: Stopwatch,
  success: Success,
  "tick-small": TickSmall,
  tick: Tick,
  time: Time,
  trash: Trash,
  "triangle-down": TriangleDown,
  "triangle-up": TriangleUp,
  twitter: Twitter,
  "warning-or-significant": WarningOrSignificant,
  youtube: Youtube
};